export default __webpack_public_path__ + "static/CCDE_mobile_400x600-b33a782f7e55b1ec48d43eeeac4346cf.jpg";